import { useEffect } from 'react';

const API = 'https://chatbotapi.pluxinfosystems.com';
const SCRIPT_ID = 'pluxchatbot-widget';
const SCRIPT_V = '20261003-resume';

type Props = {
  site?: 'plux' | 'naukries' | 'indiasellers' | 'kailash';
  title?: string;
};

function injectWidget(site: string, title: string) {
  if (typeof document === 'undefined') return;

  const existing = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
  if (existing) {
    // Keep a live early/boot script; only refresh data attrs if needed.
    existing.setAttribute('data-site', site);
    existing.setAttribute('data-title', title);
    if (document.getElementById('pluxchatbot-root')) return;
  }

  // Drop dead prerendered shells without wiping a healthy live root.
  const root = document.getElementById('pluxchatbot-root');
  if (root && !root.querySelector('.pluxcb-launcher')) {
    root.remove();
  }

  if (document.getElementById(SCRIPT_ID) && document.getElementById('pluxchatbot-root')) {
    return;
  }

  document.getElementById(SCRIPT_ID)?.remove();
  document.getElementById('pluxchatbot-css')?.remove();

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = `${API}/widget.js?v=${SCRIPT_V}`;
  script.async = true;
  script.setAttribute('data-api', API);
  script.setAttribute('data-site', site);
  script.setAttribute('data-title', title);
  script.setAttribute('data-assistant', 'Sia');
  (document.body || document.documentElement).appendChild(script);
}

// Inject as soon as this chunk evaluates — do not wait for React commit (Windows delay).
if (typeof window !== 'undefined') {
  const early = () => injectWidget('plux', 'Chat with Sia');
  if (document.body) early();
  else document.addEventListener('DOMContentLoaded', early, { once: true });
}

export default function PluxChatWidget({ site = 'plux', title = 'Chat with Sia' }: Props) {
  useEffect(() => {
    injectWidget(site, title);
  }, [site, title]);

  return null;
}
